import GoodInfoColumn from './goodInfoColumn';

export default GoodInfoColumn;
